(ns ui.mcp.hint
  "Numbered hint markers for the Storrito MCP guide.

   A `marker` sits on the spot of a mockup that the help text refers to,
   `hint-list` renders the matching numbered explanations next to the
   mockup. Markers carry a `:data-hint` attribute, so a test can collect
   them from the hiccup of a mockup and check that every marker has a
   hint and every hint a marker."
  (:require [clojure.walk :as walk]))

(def badge-class
  ["inline-flex" "items-center" "justify-center" "h-5" "w-5" "shrink-0"
   "rounded-full" "bg-storrito-500" "text-white" "text-xs" "font-bold"
   "leading-none"])

(defn badge
  "The numbered circle, without the marker semantics. Used by
   `hint-list` for the numbering of the explanations."
  [n]
  [:span {:class badge-class}
   (str n)])

(defn marker
  "The numbered badge placed inline on a mockup. `n` starts at 1."
  [n]
  [:span {:class (into ["shadow" "ring-2" "ring-white"] badge-class)
          :data-hint n}
   (str n)])

(defn markers
  "The numbers of all markers in the `hiccup` of a mockup, for tests."
  [hiccup]
  (let [found (atom [])]
    (walk/postwalk (fn [x]
                     (when (and (map? x) (contains? x :data-hint))
                       (swap! found conj (:data-hint x)))
                     x)
                   hiccup)
    @found))

(defn hint-list
  "The explanations for the markers of one mockup, numbered from 1 in
   the order of `hints`. A hint is a string or a hiccup fragment."
  [hints]
  (into [:ol {:class ["space-y-3"]}]
        (map-indexed
          (fn [i hint]
            [:li {:class ["flex" "gap-3" "items-start"]}
             (badge (inc i))
             [:span {:class ["text-sm" "text-gray-700" "leading-relaxed"]}
              hint]])
          hints)))
